<template>
  <div>
    <el-form v-model="formData" label-width="100px" size="small">
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item :label="$l('goods_label_orderGoodsNo') || '产品编号'">
            <b-form-input
              size="sm"
              :placeholder="$l('tips_input_orderGoodsNo') || '请输入产品编号'"
              clearable
              type="search"
              v-model.trim="formData.orderGoodsNo"
              @keyup.enter="query()"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$l('goods_label_orderGoodsName') || '产品名称'">
            <b-form-input
              size="sm"
              :placeholder="$l('tips_input_orderGoodsName') || '请输入产品名称'"
              clearable
              type="search"
              v-model.trim="formData.orderGoodsName"
              @keyup.enter="query()"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <b-button
            class="mr-2"
            size="sm"
            variant="outline-primary"
            @click="query()"
          >
            {{ $l('INDEX.btn_search') || '搜索' }}
          </b-button>
          <b-button
            class="mr-2"
            size="sm"
            variant="outline-success"
            @click="$emit('openAddDialog', { type: 'add' })"
            :disabled="disabled"
          >
            {{ $l('INDEX.btn_add') || '添加' }}
          </b-button>
          <!-- <b-button
            class="mr-2"
            size="sm"
            variant="outline-danger"
            @click="$emit('batchDel')"
            :disabled="disabled"
          >
            {{ $l('INDEX.btn_delete') || '删除' }}
          </b-button> -->
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
export default {
  props: { disabled: { type: Boolean, default: false } },
  data() {
    return {
      formData: {}
    }
  },
  methods: {
    query() {
      this.$emit('query', this.formData)
    }
  }
}
</script>
<style lang="scss" scoped>
.el-form .el-form-item {
  margin-bottom: 0 !important;
}
</style>
